import { render, staticRenderFns } from "./JAddress.vue?vue&type=template&id=01028f27"
import script from "./JAddress.vue?vue&type=script&lang=js"
export * from "./JAddress.vue?vue&type=script&lang=js"
import style0 from "./JAddress.vue?vue&type=style&index=0&id=01028f27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports